import { render, staticRenderFns } from "./newScanCode.vue?vue&type=template&id=339f7cb8&scoped=true&"
import script from "./newScanCode.vue?vue&type=script&lang=js&"
export * from "./newScanCode.vue?vue&type=script&lang=js&"
import style0 from "./newScanCode.vue?vue&type=style&index=0&id=339f7cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339f7cb8",
  null
  
)

export default component.exports